const separator = document.querySelectorAll(".separator");

separator?.forEach((el) => {
  el.innerHTML =
    '<svg class="icon size-7 rotate-90"><use href="#icon-Arrow-12"/></svg>';
});
